module.exports = __webpack_public_path__ + "react/assets/TriggeringModal/Preview/LocalNotifications/Background/mobileIOS.png";